<template>
  <div>
    <!-- <van-nav-bar
        title="东西部交易网深圳馆"
        left-arrow
        @click-left="onClickLeft"
        /> -->
    <div class="login-container">
        <div class="content">
            <img src="https://img.zhujiaxian.com/2024/09/ca52bae1504249148491cf7919b07baf.png"  class="c-logo">
            <div class="title"></div>
            <div class="msg">申请获得你的公开信息（昵称、头像等）</div>
        </div>
        <div class="login-phone">
            <van-button type="primary" class="authorized-btn" @click="toMobile">短信验证码登陆（注册）</van-button>
        </div>
         <!-- <div class="login-phone">
            <van-button type="primary" class="authorized-btn" @click="toPasswordLogin">账户密码登陆（注册）</van-button>
        </div> -->
        <div style="text-align:center;">
            <div style="width:100%;display:flex;justify-content:center;align-items: center;color: #999;font-size: 14px;">
                <van-checkbox v-model="checked" checked-color="#0ab906">我已阅读并同意</van-checkbox>
                <router-link to="/about" style="color: sandybrown;">《服务协议》</router-link>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
    computed: {
        ...mapGetters([
            'getActivityId'
        ])
    },
    data() {
        return{
            checked:false,
        }
    },
    methods:{
        onClickLeft() {
            this.$router.go(-1);
        },
        toMobile(){
            if(this.checked == false){
                this.$toast.fail("请先阅读并同意隐私协议");
                return
            }
            this.$router.push({path: '/mobilelogin'})
        },
        toPasswordLogin(){
            if(this.checked == false){
                this.$toast.fail("请先阅读并同意隐私协议");
                return
            }
            this.$router.push({path: '/passwordlogin'})
        }
    }
}
</script>
<style lang="less" scoped>
.login-container {
    position: relative;
    height: 100%;
    width: 100%;
    padding-top: 30%;
    box-sizing: border-box;
    img{
        display: block;
        width: 75px;
        height: 75px;
        margin: auto;
        border-radius: 50%;
    }
    .title {
    font-size: 14px;
    color: #333;
    width: 100%;
    text-align: center;
    margin-top: 10px;
    }
    .msg {
        font-size: 12px;
        color: #666;
        width: 100%;
        text-align: center;
        margin-top: 5px;
    }
    .login-phone {
        width: 100%;
        margin: 15px auto;
        text-align: center;
        .authorized-btn {
            width: 88%;
            margin: 0 auto;
            text-align: center;
            background-color: #0ab906;
            border: 1px solid #0ab906;
            color: #fff;
            border-radius: 3px;
            font-size: 13px;
        }
    }
}
</style>
